import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: grid;
  position: relative;
`

export const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-bottom: 5px;

  max-height: 75px;
  overflow: auto;
`
